
// apiService.js
import { API_PASSWORD } from '../config';
import { getSubdomain, fetchWithAuth } from '../helpers';

export const getBanks = async () => {
    const subdomain = getSubdomain();
    const apiUrl = `https://${subdomain}.restocash.app/api/banks?api_password=${API_PASSWORD}`;
  
    const token = localStorage.getItem("token");
  
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  
    const data = await response.json();
  
    if (!response.ok) {
      throw new Error(data.message || "فشل في تحميل البنوك.");
    }
  
    return data.data || [];
  };


export const createBank = async ({ name, type, discount_percentage, account_number, root_ids }) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/create/new/bank`;

  const params = new URLSearchParams();
  params.append("api_password", API_PASSWORD);
  params.append("name", name);
  params.append("type", type);
  params.append("discount_percentage", discount_percentage);
  params.append("account_number", account_number);
  root_ids.forEach(id => params.append("root_ids[]", id));

  const response = await fetchWithAuth(`${apiUrl}?${params.toString()}`, {
    method: "POST",
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "❌ فشل في إنشاء البنك.");
  }

  return data;
};



export const updateBank = async ({ id, name, type, discount_percentage, account_number }) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/update/bank?api_password=${API_PASSWORD}`;

  const params = new URLSearchParams({
    id,
    name,
    type,
    discount_percentage,
    account_number
  });

  const token = localStorage.getItem("token");

  const response = await fetch(`${apiUrl}&${params.toString()}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  const result = await response.json();

  if (!response.ok) {
    throw new Error(result?.message || "فشل في تحديث بيانات البنك");
  }

  return result?.data;
};



export const assignBranchToBank = async (bankId, rootIds = []) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/add/new/root/bank`;

  const params = new URLSearchParams();
  params.append("api_password", API_PASSWORD);
  params.append("id", bankId);
  rootIds.forEach(id => params.append("root_ids[]", id));

  const token = localStorage.getItem("token");

  const response = await fetch(`${apiUrl}?${params.toString()}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    }
  });

  const result = await response.json();

  if (!response.ok) {
    throw new Error(result?.message || "فشل في ربط الفرع بالحساب");
  }

  return result.data;
};

export const removeBranchFromBank = async (bankId, rootIds = []) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/remove/root/bank`;

  const params = new URLSearchParams();
  params.append("api_password", API_PASSWORD);
  params.append("id", bankId);
  rootIds.forEach(id => params.append("root_ids[]", id));

  const token = localStorage.getItem("token");

  const response = await fetch(`${apiUrl}?${params.toString()}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    }
  });

  const result = await response.json();

  if (!response.ok) {
    throw new Error(result?.message || "فشل في إلغاء ربط الفرع.");
  }

  return result.data;
};

export const addUserBanks = async ({ user_id, bank_ids = [], permissions = {} }) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/add/user/bank?api_password=${API_PASSWORD}`;

  const token = localStorage.getItem("token");

  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      user_id,
      bank_ids,
      permissions, // لازم تكون object مش array
    }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data?.message || "فشل في إضافة صلاحيات الخزن للمستخدم");
  }

  return data;
};
